import { getSupplierPending, getSupplierSuccess, getSupplierFail, 
    deleteSupplierPending, deleteSupplierSuccess, deleteSupplierFail,
    getSSupplierPending, getSSupplierSuccess, getSSupplierFail, 
    createSupplierPending, createSupplierSuccess, createSupplierFail, 
    modifySupplierPending, modifySupplierSuccess, modifySupplierFail } from "./supplierSlice";
import { fetchAllSupplier, supplierDelete, supplierCreation, supplierModify, fetchSingleSupplier } from "../../../api/userApi";
import Swal from "sweetalert2";


export const getAllSupplier = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getSupplierPending());
        const result = await fetchAllSupplier();
       
        const myJSON = JSON.stringify(result);

     
        const myObj = JSON.parse(myJSON);
        const supplierdetails = JSON.parse(JSON.stringify(myObj.supplier));
        const supplierdetails1 = JSON.parse(JSON.stringify(supplierdetails));
        console.log('supplierdetails ' + supplierdetails);
        if (supplierdetails) {
        
            return dispatch(getSupplierSuccess(supplierdetails));
        }
        dispatch(getSupplierFail("Supplier is not found"));


    } catch (error) {
        console.log(error);
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        console.log(err);
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getSupplierFail(err.msg));

    }
}

export const supplierDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteSupplierPending());
        const result = await supplierDelete(frmDt);
        result.status ==="success" 
        ? dispatch(deleteSupplierSuccess("Supplier deleted"))
        : dispatch(deleteSupplierFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
        dispatch(deleteSupplierFail(err.msg));
    }
    
}

export const newSupplierCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createSupplierPending());
        const result = await supplierCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createSupplierSuccess(result.message))
            : dispatch(createSupplierFail(result.message));


    } catch (error) {
         
         console.log(error);
         const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire(err.msg, '', 'error')
          dispatch(createSupplierFail(err.msg));    
    }

}

export const getSingleSupplier = (id) => async (dispatch) => {
    
 
 console.log('service id : '+id);
    try {
     //call the api
    dispatch(getSSupplierPending());
    const result = await fetchSingleSupplier(id);
   // const userData=JSON.parse(result.user);
 console.log('SupplierData ');
 //console.log(result);
 console.log(result.supplier);
 
 //console.log('check user profile out if');
    if(result.supplier[0] && result.supplier[0].id){
    //console.log('check user profile');
        return dispatch(getSSupplierSuccess(result.supplier[0]));
    }
    dispatch(getSSupplierFail("Supplier is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSSupplierFail(err.msg));
 
 }
    
 
 }




export const supplierModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifySupplierPending());
        const result = await supplierModify(frmDt);
        result.status === "success"
            ? dispatch(modifySupplierSuccess(result.message))
            : dispatch(modifySupplierFail(result.message));


    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error')
     
        dispatch(modifySupplierFail(err.msg));
    }

}
